import { TimeConditionService } from '@pbx/services/TimeConditionService';
import { snakeStore, SORT_DIRECTION, SORT_COLUMN } from '@/plugins/vuex-async-pagginate';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'name',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => TimeConditionService.getTableList(params)
    }
  },
  true
);
